const e = "languagesWrapper_S13vX", a = "languageSelectorContainer_zRDQ7", n = {
  languagesWrapper: e,
  languageSelectorContainer: a
};
export {
  n as default,
  a as languageSelectorContainer,
  e as languagesWrapper
};
//# sourceMappingURL=languages.module.scss.js.map
